import { Component } from '@angular/core';
import { TagOptionsComponent } from '../tag-options/tag-options.component';
import { OrderTagsService } from '../../../../../../data-services/order-tags.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-order-tag-options',
  templateUrl: '../tag-options/tag-options.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class OrderTagOptionsComponent extends TagOptionsComponent {
  tagOptions$ = this.tagsService.tags$;

  constructor(private tagsService: OrderTagsService) {
    super();
  }
}
